<template>
  <div class="teacher-courses-list wrapper">
    <template v-if="initLoading">
      <Loading :show="initLoading" />
    </template>
    <template v-if="Object.keys(dataList).length&&(dataList.shortGoodsList.length+dataList.longGoodsList.length+dataList.recordGoodsList.length)">
      <div class="container-courses">
        <div class="courses-wrapper">
          <div v-if="dataList.shortGoodsList.length">
            <div class="term-type">
              <img class="icon" v-lazy-load data-src="~assets/images/teacher/term_icon.png">
              <div> {{ $t('teacher.shortTerm') }}</div>
            </div>
            <div class="row-list">
              <div v-for="(classItem,index) in dataList.shortGoodsList" :key="index" class="hover-transition-linear course-wrap">
                <ClassCard card-class="short-card" :card-data="classItem" :show-original-price="true"
                           :show-taxation-desc="true" :group-buy="classItem.activityItem" :show-price-is-include="classItem.showPriceIsInclude===1" :show-card-bottom-left="true"
                           :total-lessons="classItem.spec.lessonCount" :left-lessons="classItem.spec.leftLesson"
                           :show-right-top-tag="!classItem.spec.courseClosed"
                           :show-back-stamp="true"
                           :tag-type="getClassHotTagType(classItem.store, classItem.sellStore, classItem.remainSellTime)"
                />
              </div>
            </div>
          </div>
          <div v-if="dataList.longGoodsList.length">
            <div class="term-type">
              <img class="icon" v-lazy-load data-src="~assets/images/teacher/term_icon.png">
              <div>    {{ $t('teacher.longTerm') }}</div>
            </div>
            <div class="row-list">
              <div v-for="(classItem,index) in dataList.longGoodsList" :key="index" class="hover-transition-linear course-wrap">
                <ClassCard card-class="short-card" :card-data="classItem" :show-original-price="true"
                           :show-taxation-desc="true" :group-buy="classItem.activityItem" :show-price-is-include="classItem.showPriceIsInclude===1" :show-card-bottom-left="true"
                           :total-lessons="classItem.spec.lessonCount" :left-lessons="classItem.spec.leftLesson"
                           :show-right-top-tag="!classItem.spec.courseClosed"
                           :show-back-stamp="true"
                           :tag-type="getClassHotTagType(classItem.store, classItem.sellStore, classItem.remainSellTime)"
                />
              </div>
            </div>
          </div>
          <div v-if="dataList.recordGoodsList && dataList.recordGoodsList.length">
            <div class="term-type">
              <img class="icon" v-lazy-load data-src="~assets/images/teacher/term_icon.png">
              <div>{{ this.$t('featureComponents.Goods.recordedCourse') }}</div>
            </div>
            <div class="row-list">
              <RecordingCard
                v-for="data in dataList.recordGoodsList"
                :key="data.id"
                :is-common="true"
                :has-bottom="true"
                :has-border="false"
                :bottom-content="'price'"
                :card-data="data"
                class="recorded-courses"
                @click.native="clickRecording(data)"
              />
            </div>
          </div>
          <!-- <div class="load-more">
            <el-button
              v-if="!isLoadend"
              plain
              round
              :loading="buttonLoading"
              @click="loadMore"
            >
              Load More
            </el-button>
          </div> -->
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import coursesCommon from 'mixins/courses/common.js'
import ClassCard from 'components/courses/ClassCard'
import Loading from 'components/common/Loading/index.vue'
import RecordingCard from '@/components/global/FeatureComponents/Goods/RecordedCommonCoursesCard/web'

import { oneApi } from 'config/api'

export default {
  components: { ClassCard, Loading, RecordingCard },
  mixins: [coursesCommon],
  props: {
    teacherId: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      pageSize: 12,
      // 当前页码
      pageNum: 1,
      isLoadend: false,
      initLoading: false,
      buttonLoading: false,

      dataList: {},
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.initLoading = true
      this.dataList = {}
      this.pageNum = 1;
      this.loadData()
    },
    async loadData() {
      const data = {
        teacherId: this.teacherId,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      }
      const res = await this.$axios.post(oneApi.queryTeacherClazz, data, { rewritePostBody: true })
      if (Number(res.code) !== 0) {
        this.$ElMessage.error(res.msg);
        this.initLoading = false;
        return
      }
      this.dataList = res.data
      this.initLoading = false;
      this.$emit('listLength', this.dataList.shortGoodsList.length + this.dataList.longGoodsList.length + this.dataList.recordGoodsList.length);
    },
    clickRecording(item) {
      this.$router.push(`/courses/recorded-detail/${item.id}`)
    },
  },
}
</script>
<style lang="scss" scoped>
.teacher-courses-list {
  padding: 40px 40px 0 40px;
  background: rgba(255, 255, 255, 0.5);
  overflow: hidden;
  margin-top: 40px;
  border-radius: 12px;
  .class-card-wrapper.short-card {
    width: 370px;
  }

  .courses-wrapper {
    .term-type {
      width: fit-content;
      height: 42px;
      margin-bottom: 24px;
      background: var(--txt-color-link);
      border-radius: 3px 6px 6px 3px;
      font-size: 20px;
      font-weight: 600;
      color: #fff;
      line-height: 24px;
      transform: skewX(-10deg);
      overflow: visible;
      padding-left: 10px;
      position: relative;

      .icon {
        transform: skewX(10deg);
        position: absolute;
        left: -20px;
        z-index: 2;
        width: 42px;
        height: 42px;
      }

      div {
        padding: 9px 12px 9px 30px;
        transform: skewX(10deg);
        background: var(--txt-color-link);
        border-radius: 6px;
        margin-right: -10px;
      }
    }

    .row-list {
      display: flex;
      flex-wrap: wrap;

      .course-wrap {
        margin-bottom: 50px;
        top: -5px;

        &:nth-child(3n + 2) {
          margin-left: 20px;
          margin-right: 20px;
        }
        //   &:only-of-type { margin: 0 auto; }
      }
    }
  }

  .recorded-courses {
    width: 370px;
    margin-bottom: 50px;
    cursor: pointer;

    &:nth-child(3n + 2) {
      margin-left: 20px;
      margin-right: 20px;
    }
  }
}
</style>
